/**
 * These are currently configured to align/abstract out antd grid sizing
 * https://ant.design/components/grid/
 */

export const GUTTER_SIZE: { [size: string]: [number, number] } = {
  small: [10, 10],
  large: [16, 16],
};
